module.exports = __webpack_public_path__ + "img/Frame4297.51377705.png";